import React, {Fragment} from 'react';
import {Goals, Layout, Button, Flex} from 'components';
import {modal, useDragStart, useNamedSelector} from 'helpers';

export function View({ match: { params: { id } } }) {
  const project = useNamedSelector('goals.project', { id });
  const goals = useNamedSelector('goals.byProjectId');
  return project && (
    <>
      <Layout.Header>
        <Flex className="middle">
          <h5 className="pull-left">{project.name}</h5>
          <Button to={`/goals/set/?project_id=${id}&redirect=${encodeURIComponent(`/goals/projects/${id}/`)}`} icon="plus" className={['small', 'primary']}>Goal</Button>
        </Flex>
      </Layout.Header>
      { !goals[id]
        ? 'The project contains no goals.'
        : goals[id].map(goal =>
          <Goals.Single.Card
            key={goal.id}
            hasThumbnail
            navLink={`/goals/${goal.id}/`}
            id={goal.id}
            {...useDragStart({type: 'goal', typeId: goal.typeId, id: goal.id})}
          />
        )
      }
    </>
  );
}
